import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, NAV_LINKS, MEDIA } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-3">
          <div>
            <img src={MEDIA.logo} alt="Fast Life Studio Agency" className="h-14 w-auto rounded-lg" />
            <p className="font-accent text-[11px] uppercase tracking-[0.35em] text-teal-light/80 mt-3">
              Il cinema di strada
            </p>
            <p className="mt-5 text-sm text-slate-400 max-w-xs leading-relaxed">
              Agenzia di produzione contenuti social per aziende e attività locali. Video
              professionali per Instagram, Facebook e TikTok.
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Menu</p>
            <div className="mt-4 grid grid-cols-2 gap-2">
              {NAV_LINKS.map((l) => (
                <a key={l.href} href={l.href} className="text-sm text-slate-300 hover:text-teal-light transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Contatti</p>
            <div className="mt-4 space-y-3">
              <a href={`tel:+${CONTACT.whatsappNumber}`} className="flex items-center gap-3 text-sm text-slate-300 hover:text-teal-light transition-colors">
                <Phone size={16} /> {CONTACT.phoneDisplay}
              </a>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm text-slate-300 hover:text-teal-light transition-colors">
                <Mail size={16} /> {CONTACT.email}
              </a>
              <p className="flex items-start gap-3 text-sm text-slate-300">
                <MapPin size={16} className="mt-0.5 shrink-0" /> {CONTACT.addressLine}, {CONTACT.city}
              </p>
              <div className="flex items-center gap-4 pt-2">
                <a data-testid="social-instagram" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-teal-light transition-colors"><Instagram size={20} /></a>
                <a data-testid="social-facebook" href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-teal-light transition-colors"><Facebook size={20} /></a>
                <a data-testid="social-tiktok" href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-teal-light transition-colors" aria-label="TikTok">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.4a5.66 5.66 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15V8.9a7.34 7.34 0 0 0 4.3 1.38V7.19a4.28 4.28 0 0 1-3.24-1.37z"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Fast Life Studio Agency. Tutti i diritti riservati.</p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-teal-light transition-colors">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
